import { NavLink } from "react-router-dom";
import { UseUserAuth } from './context/UseAuthContext';

export default function PhotoStoriesShowcase() {
    const { user } = UseUserAuth();

    return (
      <div className="bg-white py-12 sm:py-16">
        <div className="mx-auto max-w-5xl px-6 lg:px-8">
          {/* Header */}
          <div className="mx-auto max-w-2xl text-center mb-8">
            <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl mb-3">
              Photo Stories in Action
            </h2>
            <p className="text-base text-gray-600">
              Upload real family photos → Get personalized story characters
            </p>
          </div>
  
          {/* Compact Before & After Layout */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2">
              
              {/* Left Side - Real Photos */}
              <div className="p-6 bg-gray-50 border-r border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">
                  Your Family Photos
                </h3>
                <div className="space-y-2 max-w-xs mx-auto">
                <div className="text-center">
                    <img 
                      src="https://static.mytalemaker.com/real-child.webp"
                      alt="Child"
                      className="w-40 h-60 object-cover rounded-lg shadow-sm mx-auto"
                    />
                    <p className="text-xs text-gray-500 mt-1">Child</p>
                  </div>
                  <div className="text-center">
                    <img 
                      src="https://static.mytalemaker.com/real-mom.webp" 
                      alt="Mom"
                      className="w-40 h-60 object-cover rounded-lg shadow-sm mx-auto"
                    />
                    <p className="text-xs text-gray-500 mt-1">Mom</p>
                  </div>
            
                  <div className="text-center">
                    <img 
                      src="https://static.mytalemaker.com/real-dad.webp"
                      alt="Dad"
                      className="w-40 h-60 object-cover rounded-lg shadow-sm mx-auto"
                    />
                    <p className="text-xs text-gray-500 mt-1">Dad</p>
                  </div>
                </div>
              </div>
  
              {/* Right Side - AI Story Images */}
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">
                  Your Story Characters
                </h3>
                <div className="space-y-3">
                  <div className="text-center">
                    <img 
                      src="https://static.mytalemaker.com/story-dad-child.webp"
                      alt="Dad and child story scene"
                      className="w-full h-96 object-cover object-top rounded-lg shadow-sm"
                    />
                   
                  </div>
                  
                  <div className="text-center">
                    <img 
                      src="https://static.mytalemaker.com/story-mom-child.webp"
                      alt="Mom and child story scene"
                      className="w-full h-96 object-cover object-top rounded-lg shadow-sm"
                    />
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          {/* Simple CTA */}
          <div className="text-center mt-8">
            <p className="text-gray-600 mb-4">
              Ready to see your family's transformation?
            </p>
            <NavLink
                    to={user ? '/create' : "/signup"}
                    className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Start Your Free Story
                  </NavLink>
          </div>
        </div>
      </div>
    );
  }